import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RecruitmentXLogo from './rx_logo_white.svg';

const PaymentSuccessPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/login');
        }, 5000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div style={styles.container}>
            <style>
                {`
                    @keyframes fadeInUp {
                        from {
                            opacity: 0;
                            transform: translateY(30px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    @keyframes pulse {
                        0%, 100% {
                            transform: scale(1);
                            opacity: 0.8;
                        }
                        50% {
                            transform: scale(1.05);
                            opacity: 1;
                        }
                    }
                    
                    @keyframes glow {
                        0%, 100% {
                            box-shadow: 0 0 20px rgba(255, 255, 255, 0.1),
                                        0 0 40px rgba(255, 255, 255, 0.05);
                        }
                        50% {
                            box-shadow: 0 0 30px rgba(255, 255, 255, 0.2),
                                        0 0 60px rgba(255, 255, 255, 0.1);
                        }
                    }
                    
                    @keyframes progress {
                        from {
                            width: 0%;
                        }
                        to {
                            width: 100%;
                        }
                    }
                `}
            </style>
            <div style={styles.card}>
                <img 
                    src={RecruitmentXLogo} 
                    alt="RecruitmentX" 
                    style={styles.logo}
                />
                <h1 style={styles.title}>Payment Successful!</h1>
                <p style={styles.subtitle}>Welcome to RecruitmentX</p>
                <div style={styles.progressBar}>
                    <div style={styles.progressFill}></div>
                </div>
                <p style={styles.redirect}>Redirecting to login...</p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #141414 0%, #1f1520 50%, #141414 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    card: {
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        borderRadius: '24px',
        padding: '60px 80px',
        textAlign: 'center',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        animation: 'fadeInUp 0.6s ease-out, glow 2s ease-in-out infinite',
        maxWidth: '500px',
    },
    logo: {
        height: '70px',
        marginBottom: '40px',
        animation: 'pulse 2s ease-in-out infinite',
    },
    title: {
        color: '#ffffff',
        fontSize: '36px',
        fontWeight: '600',
        marginBottom: '15px',
        animation: 'fadeInUp 0.6s ease-out 0.2s backwards',
    },
    subtitle: {
        color: '#cccccc',
        fontSize: '20px',
        marginBottom: '40px',
        animation: 'fadeInUp 0.6s ease-out 0.3s backwards',
    },
    progressBar: {
        width: '100%',
        height: '4px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '2px',
        overflow: 'hidden',
        marginBottom: '20px',
    },
    progressFill: {
        height: '100%',
        background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
        borderRadius: '2px',
        animation: 'progress 5s ease-out forwards',
        width: '0%',
    },
    redirect: {
        color: '#999999',
        fontSize: '14px',
        animation: 'fadeInUp 0.6s ease-out 0.4s backwards',
    }
};

export default PaymentSuccessPage;

